import { State } from '../state';

export const clients: State = {
    url: 'clients'
};

export const newClient: State = {
    url: 'clients/new',
    oldUrls: ['client/new'],
    parent: clients
};

export const editClient: State = {
    url: 'clients/edit',
    oldUrls: ['client/edit'],
    parent: clients
};
